import { render, staticRenderFns } from "./SelectBoxDialog.vue?vue&type=template&id=2de1ec54&scoped=true&"
import script from "./SelectBoxDialog.vue?vue&type=script&lang=js&"
export * from "./SelectBoxDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectBoxDialog.vue?vue&type=style&index=0&id=2de1ec54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de1ec54",
  null
  
)

export default component.exports